import { Injectable } from '@angular/core';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { PropertyAnalysisService } from './property-analysis.service';
import { PropertyService } from './property.service';

@Injectable()
export class PrintService {

    constructor(
        private currency: CurrencyPipe,
        private percent: PercentPipe,
        private analysis: PropertyAnalysisService,
        private propertyService: PropertyService
    ) {}

    setupPrintFrame() {
        const iframe = document.createElement('iframe');

        iframe.width = '0';
        iframe.height = '0';
        iframe.hidden = true;
        iframe.classList.add('ion-hide');
        document.body.append(iframe);

        return iframe;
    }

    async printFlyer(property: Parse.Object, estatedInfo: any, annualTaxes: string, hoa: string, garageSize: string) {
        const iframe = this.setupPrintFrame();

        (iframe.contentWindow as any).document.body.innerHTML = await this.generateFlyerContent(property, estatedInfo, annualTaxes, hoa, garageSize);

        // Give iframe time to load image.
        setTimeout(() => {
            (iframe.contentWindow as any).print();
        }, 1000);
    }

    async generateFlyerContent(property: Parse.Object, estatedInfo: any, annualTaxes: string, hoa: string, garageSize: string) {
        const numBeds = estatedInfo.structure.beds_count || 'N/A';
        const numBaths = estatedInfo.structure.baths || 'N/A';
        const sqFt = estatedInfo.structure.total_area_sq_ft || 'N/A';

        const ppsfValue = (property.get('marketingPurchasePrice') / estatedInfo.structure.total_area_sq_ft);
        const ppSf = this.currency.transform(ppsfValue, 'USD', 'symbol', '1.2-2');
        const marketRent = property.get('saRental').get('rentMonthly') ? this.currency.transform(property.get('saRental').get('rentMonthly')) : 'N/A';

        const streetView = this.propertyService.getStreetViewUrl(
            property.get('address'),
            property.get('city'),
            property.get('zip'),
            property.get('state'),
            640,
            380);
        const imageUrl = property.has('coverPhoto') ? property.get('coverPhoto').get('file').url() : streetView;

        const analysisLeftCol = property.get('type') === 'rental/flip' ? 'Rental' : 'Cash';
        const analysisRightCol = property.get('type') === 'rental/flip' ? 'Flip' : 'Finance';
        // const zillowInfo = await Parse.Cloud.run('zestimate', { property: property.toJSON() });

        // zillowInfo.sellZestimate.thirtyDayChange = +zillowInfo.sellZestimate.thirtyDayChange + +zillowInfo.sellZestimate.amount;
        // zillowInfo.rentZestimate.thirtyDayChange = +zillowInfo.rentZestimate.thirtyDayChange + +zillowInfo.rentZestimate.amount;
        //
        // const zestimate = +zillowInfo.sellZestimate.amount;
        // const price = property.get('marketingPurchasePrice');
        //
        // let percentBelow = (price - zestimate) / zestimate;
        // let showPricePercentage = true;
        //
        // if (percentBelow > 0) {
        //     showPricePercentage = false;
        // } else {
        //     percentBelow = -1 * percentBelow;
        // }
        //
        // const percentBelowZestimate = this.percent.transform(percentBelow, '1.0-0');

        let html = `<head>
            <style>
                body { padding: 0 10px 10px; }
                nav { text-align: center; border-bottom: 1px solid #F2F2F2; margin-bottom: 20px; padding: 20px; }
                .header { font-weight: bold; margin-bottom: 50px; }
                .address { font-size: 20px; margin-bottom: 15px; }
                .details { font-size: 16px; }
                .cover-image { height: 300px; width: 500px; margin: 0 auto 50px; }
                .cover-image img { width: 100%; height: 100%; }
                .image-grid-item img { width: 100%; height: 100%; }
                .content { display: flex; }
                .content-left-col { flex: 1; margin-right: 50px; }
                .content-right-col { flex: 1; }
                .overview { border-radius: 1px; border: 1px solid #cacaca; padding: 5px 20px; }
                .overview__content { display: flex; }
                .overview__content-left { flex: 1; }
                .overview__label { margin-bottom: 10px; }
                .overview__value { font-weight: bold; font-size: 18px; margin-bottom: 30px; }
                .overview__content-right { flex: 1; }
                .analysis { border-radius: 1px; border: 1px solid #cacaca; padding: 5px 20px; margin-top: 100px; margin-bottom: 30px; }
                .analysis__title { font-weight: bold; border-bottom: 1px solid #d5d5d4; margin-bottom: 15px; margin-top: 5px; padding: 10px 0; font-size: 18px; color: #215890; }
                .analysis__content-left,
                .analysis__content-middle,
                .analysis__content-right { flex: 1; }
                .analysis__col-header { font-weight: bold; margin-bottom: 20px; }
                .analysis__col { margin-bottom: 20px; display: flex; flex-direction: column; }
                .structure { height: 100%; display: flex; flex-direction: column; }
                .structure__content { display: flex; flex-direction: column; height: 100%; justify-content: space-between; }
                .structure__row { display: flex; margin-bottom: 10px; }
                .structure__col { flex: 1; }
                .structure__label { margin-bottom: 5px; }
                .structure__value { font-weight: bold; font-size: 18px; }
                .highlights { margin-bottom: 50px; }
                .zillow { display: flex; align-items: center; }
                .zillow__label { font-size: 20px; color: #215890; font-weight: bold; }
                .zillow__text { margin-left: auto; font-weight: bold; }
                .zillow-box { display: flex; border-radius: 1px; border: 1px solid #cacaca; margin-bottom: 10px; padding: 10px 0; }
                .zillow-box__left { flex: 1; padding: 20px; border-right: 1px solid #d5d5d4; }
                .zillow-box__right { flex: 1; padding: 20px; }
                .zillow-box__title { color: #989898; font-size: 18px; margin-bottom: 30px; }
                .zillow-box__row { display: flex; }
                .zillow-box__row:nth-child(even) { margin-bottom: 30px; }
                .zillow-box__col { flex: 1; }
                .zillow-disc { font-size: 12px; margin-bottom: 10px; }
                .capitalize{ text-transform: capitalize; }
            </style>
        </head>`;

        html += `<body>
                    <nav>
                        <img src="../../assets/img/logos/spectrum/spectrum_logo.jpg" height="30"/>
                    </nav>
                    <main>
                        <div class="header">
                            <div class="address capitalize">${ property.get('address') }</div>
                            <div class="details">
                                ${ numBeds } Beds |
                                ${ numBaths } Baths |
                                ${ sqFt } Sqft.
                                in <span class="capitalize">${ property.get('city') }, ${ property.get('state') }</span>
                            </div>
                        </div>

                        <div class="cover-image">
                            <img src="${ imageUrl }">
                        </div>

                        <div class="content">
                            <div class="content-left-col">
                                <div class="overview">
                                    <div class="analysis__title">Overview</div>
                                    <div class="overview__content">
                                        <div class="overview__content-left">
                                            <div class="overview__label">Purchase Price</div>
                                            <div class="overview__value">${ this.currency.transform(property.get('marketingPurchasePrice')) }</div>

                                            <div class="overview__label">PPSF</div>
                                            <div class="overview__value">${ ppSf }</div>
                                        </div>
                                        <div class="overview__content-right">
                                            <div class="overview__label">Investment Type</div>
                                            <div class="overview__value capitalize">${ property.get('type') }</div>

                                            <div class="overview__label">Market Rent</div>
                                            <div class="overview__value">${ marketRent }</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="content-right-col">
                                <div class="structure">
                                    <div class="analysis__title">Structure Details</div>
                                    <div class="structure__content">
                                        <div class="structure__row">
                                            <div class="structure__col">
                                                <div class="structure__label">Bedrooms</div>
                                                <div class="structure__value">${ numBeds }</div>
                                            </div>
                                            <div class="structure__col">
                                                <div class="structure__label">Bathrooms</div>
                                                <div class="structure__value">${ numBaths }</div>
                                            </div>
                                        </div>

                                        <div class="structure__row">
                                            <div class="structure__col">
                                                <div class="structure__label">Stories</div>
                                                <div class="structure__value">${ estatedInfo.structure.stories || 'N/A' }</div>
                                            </div>
                                            <div class="structure__col">
                                                <div class="structure__label">Total Finished Size</div>
                                                <div class="structure__value">${ estatedInfo.structure.total_area_sq_ft || 'N/A' } Sqft.</div>
                                            </div>
                                        </div>

                                        <div class="structure__row">
                                            <div class="structure__col">
                                                <div class="structure__label">Year Built</div>
                                                <div class="structure__value">${ estatedInfo.structure.year_built || 'N/A' }</div>
                                            </div>
                                            <div class="structure__col">
                                                <div class="structure__label">Annual Taxes</div>
                                                <div class="structure__value">${ annualTaxes }</div>
                                            </div>
                                        </div>

                                        <div class="structure__row">
                                            <div class="structure__col">
                                                <div class="structure__label">HOA</div>
                                                <div class="structure__value">${ hoa } / mo</div>
                                            </div>
                                            <div class="structure__col">
                                                <div class="structure__label">Exterior Walls</div>
                                                <div class="structure__value">${ estatedInfo.structure.exterior_wall_type || 'N/A' }</div>
                                            </div>
                                        </div>

                                        <div class="structure__row">
                                            <div class="structure__col">
                                                <div class="structure__label">Heating</div>
                                                <div class="structure__value">${ estatedInfo.structure.heating_type || 'N/A' }</div>
                                            </div>
                                            <div class="structure__col">
                                                <div class="structure__label">Cooling</div>
                                                <div class="structure__value">${ estatedInfo.structure.air_conditioning_type || 'N/A' }</div>
                                            </div>
                                        </div>

                                        <div class="structure__row">
                                            <div class="structure__col">
                                                <div class="structure__label">Parking Type</div>
                                                <div class="structure__value">${ estatedInfo.structure.parking_type || 'N/A' }</div>
                                            </div>
                                            <div class="structure__col">
                                                <div class="structure__label">Parking Spaces</div>
                                                <div class="structure__value">${ estatedInfo.structure.parking_spaces_count } Sqft.</div>
                                            </div>
                                        </div>

                                        <div class="structure__row">
                                            <div class="structure__col">
                                                <div class="structure__label">Zoning</div>
                                                <div class="structure__value">${ estatedInfo.parcel.standardized_land_use_category || 'N/A' }</div>
                                            </div>
                                            <div class="structure__col">
                                                <div class="structure__label">Lot Size</div>
                                                <div class="structure__value">${ estatedInfo.parcel.area_acres || 'N/A' } Acres</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;

        if (property.get('type') !== 'land') {
            html += `<div class="analysis">
                        <div class="analysis__title">Analysis</div>
                        <div class="overview__content">
                            <div class="analysis__content-left">
                                <div class="analysis__col-header">&nbsp;</div>
                                <div class="analysis__col">Price:</div>
                                <div class="analysis__col">ARV:</div>
                                <div class="analysis__col">
                                    <div>Rehab:</div>
                                    <div>&nbsp;</div>
                                </div>
                                <div class="analysis__col">ROI:</div>
                                <div class="analysis__col">${ property.get('type') === 'rental/flip' ? 'Equity' : 'Net Income' }</div>
                            </div>
                            <div class="analysis__content-middle">
                                <div class="analysis__col-header">${ analysisLeftCol }</div>
                                <div class="analysis__col">${ this.analysis.getPurchasePrice(property, 'left') }</div>
                                <div class="analysis__col">${ this.analysis.getARV(property, 'left') }</div>
                                <div class="analysis__col">`;

            if (property.get('type') === 'rental/flip' || property.get('type') === 'rental') {
                html += `<div>${ this.analysis.getRehabWord(property, 'left') }</div>`;
            } else if (property.get('type') === 'flip') {
                html += `<div>${ this.analysis.getRehabWord(property, 'right') }</div>`;
            }

            html += `<div>${ this.analysis.getRehabRange(property, 'left') }</div>
                            </div>
                            <div class="analysis__col">${ this.analysis.getROI(property, 'left') }</div>
                            <div class="analysis__col">${ this.analysis.getNetIncome(property, 'left') }</div>
                        </div>

                        <div class="analysis__content-right">
                            <div class="analysis__col-header">${ analysisRightCol }</div>
                            <div class="analysis__col">${ this.analysis.getPurchasePrice(property, 'right') }</div>
                            <div class="analysis__col">${ this.analysis.getARV(property, 'right') }</div>
                            <div class="analysis__col">
                                <div>${ this.analysis.getRehabWord(property, 'right') }</div>
                                <div>${ this.analysis.getRehabRange(property, 'right') }</div>
                            </div>
                            <div class="analysis__col">${ this.analysis.getROI(property, 'right') }</div>
                            <div class="analysis__col">${ this.analysis.getNetIncome(property, 'right') }</div>
                        </div>
                    </div>
                </div>
            </div>`;
        }

        html += `<div class="highlights">
            <div class="analysis__title">Highlights</div>
            <div class="highlights__content">
                This is the content
            </div>
        </div>`;

        // if (property.createdAt && !property.get('hideZillowInfo')) {
        //     html += `<div class="zillow">
        //         <div class="zillow__label">Valuation</div>
        //         <div class="zillow__image">
        //             <img src="../../assets/img/Zillowlogo_200x50.gif" height="50" width="200"/>
        //         </div>`;
        //
        //     if (showPricePercentage) {
        //         html += `<div class="zillow__text"> Purchase Price is ${ percentBelowZestimate } below Zestimate&reg;</div>`;
        //     }
        //     html += `</div>
        //
        //     <div class="zillow-box">
        //         <div class="zillow-box__left">
        //             <div class="zillow-box__title">Rent Zestimate&reg;</div>
        //
        //             <div class="zillow-box__row">
        //                 <div class="zillow-box__col">
        //                     <div class="structure__label">Rent Zestimate&reg;</div>
        //                     <div class="structure__value">${ this.currency.transform(zillowInfo.rentZestimate.amount, 'USD', 'symbol', '1.0-0') } / month</div>
        //                 </div>
        //
        //                 <div class="zillow-box__col">
        //                     <div class="structure__label">Range of Value</div>
        //                     <div class="structure__value">${ this.currency.transform(zillowInfo.rentZestimate.range.low, 'USD', 'symbol', '1.0-0') } - ${ this.currency.transform(zillowInfo.rentZestimate.range.high, 'USD', 'symbol', '1.0-0') }</div>
        //                 </div>
        //             </div>
        //
        //             <div class="zillow-box__row">
        //                 <div class="zillow-box__col">
        //                     <div class="structure__label">30 Day Forecast</div>
        //                     <div class="structure__value">${ this.currency.transform(zillowInfo.rentZestimate.thirtyDayChange, 'USD', 'symbol', '1.0-0') }</div>
        //                 </div>
        //
        //                 <div class="zillow-box__col">
        //                     <div class="structure__label">Last Updated</div>
        //                     <div class="structure__value">${ zillowInfo.rentZestimate.lastUpdated }</div>
        //                 </div>
        //             </div>
        //         </div>
        //
        //         <div class="zillow-box__right">
        //             <div class="zillow-box__title">Zestimate&reg;</div>
        //
        //             <div class="zillow-box__row">
        //                 <div class="zillow-box__col">
        //                     <div class="structure__label">Zestimate&reg;</div>
        //                     <div class="structure__value">${ this.currency.transform(zillowInfo.sellZestimate.amount, 'USD', 'symbol', '1.0-0') }</div>
        //                 </div>
        //
        //                 <div class="zillow-box__col">
        //                     <div class="structure__label">Range of Value</div>
        //                     <div class="structure__value">${ this.currency.transform(zillowInfo.sellZestimate.range.low, 'USD', 'symbol', '1.0-0') } - ${ this.currency.transform(zillowInfo.sellZestimate.range.high, 'USD', 'symbol', '1.0-0') }</div>
        //                 </div>
        //             </div>
        //
        //             <div class="zillow-box__row">
        //                 <div class="zillow-box__col">
        //                     <div class="structure__label">30 Day Forecast</div>
        //                     <div class="structure__value">${ this.currency.transform(zillowInfo.sellZestimate.thirtyDayChange, 'USD', 'symbol', '1.0-0') }</div>
        //                 </div>
        //
        //                 <div class="zillow-box__col">
        //                     <div class="structure__label">Last Updated</div>
        //                     <div class="structure__value">${ zillowInfo.rentZestimate.lastUpdated }</div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        //
        //     <div class="zillow-disc">
        //         &copy; Zillow, Inc., 2006-2016. Use is subject to Terms of Use
        //     </div>`;
        // }

        html += `</main></body>`;

        return html;
    }
}
